export default {
  "HitPaw Add Music to Audio Online": "HitPaw Online Adicionar Música ao Áudio",
  "Add BGM to Audio without any difficulties.": "Adicionar BGM ao áudio sem qualquer dificuldade.",
  "Add New": "Adicionar Novo",
  "Format": "Formato",
  "Add tracks": "Adicionar faixas",

};
